// Business domain constants
export const XP_PER_LEVEL = 100;
export const LEVEL_UP_DUST_REWARD = 50;
// ORACLE_ASK_COST is defined in constants/economy.ts

// Validation constants
export const MIN_PASSWORD_LENGTH = 8;
export const MIN_NAME_LENGTH = 2;

// Achievement definitions
export const ACHIEVEMENT_DEFINITIONS = [
  { id: 'FIRST_QUEST', name: 'First Quest', description: 'Complete your first quest.', reward: 25 },
  { id: 'LVL_5', name: 'Level 5', description: 'Reach level 5.', reward: 50 },
  { id: 'LVL_10', name: 'Level 10', description: 'Reach level 10.', reward: 100 },
] as const;

// Quest definitions
export const QUEST_DEFINITIONS = [
  {
    id: 'q1',
    name: 'Daily Tarot',
    description: 'Draw your daily tarot card.',
    reward: 20,
    type: 'daily_tarot',
  },
  {
    id: 'q2',
    name: 'Oracle Query',
    description: 'Ask the Oracle a question.',
    reward: 10,
    type: 'ask_oracle',
  },
  {
    id: 'q3',
    name: 'Compatibility Check',
    description: 'Check compatibility between two signs.',
    reward: 15,
    type: 'compatibility_check',
  },
  {
    id: 'q4',
    name: 'Profile Complete',
    description: 'Complete your birth profile.',
    reward: 50,
    type: 'complete_profile',
  },
  {
    id: 'q5',
    name: 'First Friend',
    description: 'Add your first friend.',
    reward: 30,
    type: 'add_friend',
  },
] as const;

// Shop items (currently disabled but keeping for future use)
export const SHOP_ITEMS = [
  { id: 'theme_default', name: 'Default Theme', cost: 0, type: 'theme' },
  { id: 'theme_nebula', name: 'Nebula Theme', cost: 200, type: 'theme' },
  { id: 'frame_default', name: 'Default Frame', cost: 0, type: 'frame' },
] as const;
